module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00043-fs8.e9bf503.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00043-fs8.png
// module id = 196
// module chunks = 0